import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { Slices } from '@yoweb/prismic-slicemachine/components/Slices';
import { WhatYouGetTemplate } from '@yoweb/prismic-slicemachine/customtypes/PageTemplateWhatYouGet';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * The Assistants page with Slices.
 */
var WhatYouGetPage = function WhatYouGetPage(_ref) {
  var slices = _ref.slices,
      meta = _ref.meta;
  return /*#__PURE__*/_jsx(Slices, {
    slices: slices,
    meta: meta,
    template: WhatYouGetTemplate
  });
}; // Please do not remove the redirect unless marketing has giving okay


WhatYouGetPage.layout = {
  type: 'marketing',
  props: {
    withTransparentHeader: false
  }
};
export var __N_SSP = true;
export default _withSuperJSONPage(WhatYouGetPage);